
(function(){
  if (window.__almStickyVar) return; window.__almStickyVar = 1;
  var PALETTE = { 'or':'#C9A227','dore':'#C9A227','doree':'#C9A227','gold':'#C9A227','noir':'#1A1814','black':'#1A1814','pierre-noire':'#2B2723','blanc':'#FAFAF8','white':'#FAFAF8','creme':'#F2EAD9','noyer':'#5C4023','walnut':'#5C4023','bois-clair':'#D8B98A','bois':'#B08D5E','chene':'#C9A46F','travertin':'#D9C7A8','travertin-beige':'#D9C7A8','travertin-jaune':'#D9B36A','beige':'#D9C7A8','gris':'#8A857D','argent':'#C9C9C9','laiton':'#C9A227','cuivre':'#B0764F','naturel':'#D8C9B0' };
  var norm = function(s){ return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').trim().replace(/\s+/g,'-'); };
  var pill = document.getElementById('almStickyVar');
  if (!pill) return;
  var label = pill.querySelector('.almsv-label');
  var dots = [].slice.call(pill.querySelectorAll('.almsv-dot'));
  dots.forEach(function(d){
    var k = norm(d.getAttribute('data-alm-value'));
    var c = PALETTE[k];
    if (!c) { var kk = Object.keys(PALETTE).find(function(p){ return k.indexOf(p) === 0 || p.indexOf(k) === 0; }); c = kk ? PALETTE[kk] : '#8A857D'; }
    d.style.background = c;
  });

  function realBtns(){ return [].slice.call(document.querySelectorAll('button[class*="mz-variant-btn-"], [class*="mz-color-swatch-"]')); }
  /* 03/09 — POURQUOI LA PASTILLE « REVENAIT AU PREMIER PRODUIT ».
     Quand le theme change de variante, il reconstruit son selecteur : pendant un
     instant DEUX etiquettes « variante selectionnee » coexistent dans la page,
     l'ancienne et la neuve. On lisait la PREMIERE — donc la peripee, restee sur la
     valeur de depart — et on repeignait la pastille avec. D'ou le retour a la
     premiere couleur et le comportement « bizarre » au clic rapide.
     On lit desormais la DERNIERE, c'est-a-dire celle que le theme vient d'ecrire. */
  function selSpan(){
    var l = document.querySelectorAll('span[class*="mz-variant-selected-"]');
    for (var i = l.length - 1; i >= 0; i--) { if (l[i].textContent.trim()) return l[i]; }
    return null;
  }

  function setSel(val){
    var k = norm(val);
    dots.forEach(function(d){ d.classList.toggle('alm-sel', norm(d.getAttribute('data-alm-value')) === k); });
    if (label && val) label.textContent = val;
  }
  var s0 = selSpan();
  setSel(s0 ? s0.textContent.trim() : (dots[0] && dots[0].getAttribute('data-alm-value')));

  /* 03/09 — CLICS RAPIDES SUR LA PASTILLE : ca revenait a la premiere variante.
     Chaque clic declenchait un changement de variante, et le theme reconstruit
     alors son selecteur. En cliquant vite, un clic partait pendant que le
     selecteur etait en train d'etre refait : on tapait sur un bouton qui
     n'existait deja plus, et la fiche retombait sur la premiere valeur.
     Deux garde-fous :
       ① un clic a la fois — les suivants sont ignores tant que le theme n'a pas fini ;
       ② on se resynchronise TOUJOURS sur ce que le vrai selecteur affiche,
          jamais sur ce qu'on croit avoir clique. */
  var CONNUES = dots.map(function(d){ return norm(d.getAttribute('data-alm-value')); });
  var enCours = false;
  /* On ne recopie QUE si le theme annonce une valeur qui existe vraiment dans la
     pastille. Un libelle inconnu (etiquette a moitie reconstruite, autre option)
     est ignore plutot que repeint de travers. */
  function resync(){
    if (enCours) return;
    var s = selSpan();
    if (!s) return;
    var t = s.textContent.trim();
    if (t && CONNUES.indexOf(norm(t)) !== -1) setSel(t);
  }
  /* 03/09 — On n'attend plus un delai fixe : on attend que le theme AFFICHE
     vraiment la valeur demandee (verification toutes les 60 ms, abandon a 1,4 s).
     Un delai fixe rendait la main trop tot sur un telephone lent, et le clic
     suivant tombait au milieu de la reconstruction du selecteur. */
  function attendre(k, fini){
    var t0 = Date.now();
    (function boucle(){
      var s = selSpan();
      if (s && norm(s.textContent) === k) return fini();
      if (Date.now() - t0 > 1400) return fini();
      setTimeout(boucle, 60);
    })();
  }
  dots.forEach(function(d){
    d.addEventListener('click', function(){
      if (enCours) return;
      var val = d.getAttribute('data-alm-value'), k = norm(val);
      var s = selSpan();
      if (s && norm(s.textContent) === k) { setSel(val); return; }
      var btn = realBtns().find(function(b){ return norm(b.textContent) === k || norm(b.getAttribute('data-value')) === k; });
      if (!btn) return;
      enCours = true;
      setSel(val);
      btn.click();
      attendre(k, function(){ enCours = false; resync(); });
    });
  });
  /* clic direct sur le vrai selecteur -> resynchroniser la pastille */
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest && e.target.closest('button[class*="mz-variant-btn-"], [class*="mz-color-swatch-"]');
    if (b) { setTimeout(resync, 120); setTimeout(resync, 600); }
  }, true);

  /* apparition : seulement quand le selecteur n'est PAS ENCORE atteint
     (il est sous l'ecran -> on regarde les photos au-dessus). Une fois le
     selecteur visible ou depasse, la pastille disparait. */
  var tries = 0;
  (function arm(){
    var btns = realBtns().filter(function(b){ var r = b.getBoundingClientRect(); return r.width > 0 && r.height > 0; });
    var anchor = btns.length ? (btns[0].parentNode || btns[0]) : document.querySelector('[class*="mz-product-info"]');
    if (!anchor) { if (++tries < 25) return setTimeout(arm, 400); return; }
    var io = new IntersectionObserver(function(entries){
      var e = entries[0];
      var pasEncoreAtteint = e.boundingClientRect.top > 0; /* selecteur encore sous l'ecran */
      pill.classList.toggle('alm-on', !e.isIntersecting && pasEncoreAtteint);
    }, { threshold: 0 });
    io.observe(anchor);
  })();
}());
